module.exports = __webpack_public_path__ + "static/mappingpolice-f04a1078a75d2215d5751b3bfbe4013b.png";